export default {"src":"/_next/static/media/conflictsManagement.3af7eafc.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};